import { type MCPServerInfo } from '../../types';

const CircleciServer: MCPServerInfo = {
  serverId: 'CIRCLECI',
  name: 'CircleCI',
  slug: 'circleci',
  description:
    'CircleCI MCP Server - Debug failed builds, find flaky tests, run pipelines, and manage CI/CD workflows',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/CircleCI-Public/mcp-server-circleci',
    commitSha: 'f0d1351',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['circleciToken'],
    properties: {
      circleciToken: {
        type: 'string',
        description: 'CircleCI Personal API Token',
        sensitive: true
      },
      circleciBaseUrl: {
        type: 'string',
        description: 'CircleCI Base URL (only required for on-prem customers)',
        sensitive: false,
        default: 'https://circleci.com'
      }
    }
  }
};

export default CircleciServer;
